import React, { useState } from 'react';
import {
  Badge,
  Button, Card, Col, Pagination, Row,
} from 'react-bootstrap';
import img from 'assets/img/oportunidadPlaceholder330px.jpg';
import { ReactComponent as IconPin } from 'assets/icons/pin.svg';
import OpportunitiesOverview from 'components/Opportunities/Overview';
import { useNavigate, generatePath } from 'react-router';
import { OPPORTUNITIES_DETAIL_ID } from 'constants/routes';
import { ReactComponent as IconArrowLeft } from 'assets/icons/arrow-left.svg';
import { ReactComponent as IconArrowRight } from 'assets/icons/arrow-right.svg';
import { FutureInvestment, PromotionDetail } from 'types/FutureInvestment';
import classNames from 'classnames';

function Opportunities( {
  projects, futureInvestment,
  opportunityInterestsme,
}: {
  futureInvestment: FutureInvestment | null;
  projects: PromotionDetail[];
  opportunityInterestsme: ( ) => void
} ) {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState( 1 );
  const itemsPerPage = 6;

  const totalPages = Math.ceil( projects.length / itemsPerPage );

  const paginatedProjects = projects.slice(
    ( currentPage - 1 ) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const maxVisible = 6;
  const generateVisiblePages = ( maxPages: number, current: number ) => {
    const half = Math.floor( maxVisible / 2 );
    let start = Math.max( current - half, 1 );
    let end = start + maxVisible;

    if ( end > maxPages + 1 ) {
      end = maxPages + 1;
      start = Math.max( end - maxVisible, 1 );
    }

    return Array.from( { length: maxPages }, ( _, i ) => i + 1 ).slice( start - 1, end - 1 );
  };

  const visiblePages = generateVisiblePages( totalPages, currentPage );

  return (
    <div className="op-dashboard">
      <Card className="mb-3 mb-lg-5 border-0">
        {!!futureInvestment && (
        <OpportunitiesOverview
          futureInvestment={futureInvestment}
          opportunityInterestsme={opportunityInterestsme}
        />
        )}

        <div className={classNames( 'bg-blue', { rounded: !futureInvestment } )}>
          <h1 className="title-xl">FONDOS FINANCIADOS</h1>
          <p className="subtitle">Accede a los últimos proyectos gestionados por Impar Capital.</p>

          <Row className="g-4 m-0 content">
            {paginatedProjects.map( ( item ) => (
              <Col lg={4} key={item.codigoPromocion}>
                <Card
                  className="card-img h-100"
                  onClick={() => navigate( generatePath(
                    OPPORTUNITIES_DETAIL_ID,
                    { id: item.codigoPromocion },
                  ), { state: { item } } )}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="card-img-wrapper">
                    <Card.Img
                      variant="top"
                      src={item.smallImageUrl?.trim() ? item.smallImageUrl : img}
                    />

                  </div>
                  <Card.Body>
                    <Badge bg="outline-gray16" text="gray16" className="badge-xs">
                      {item.estadoVentas}
                    </Badge>
                    <Card.Title>
                      <span className="text-lato-bold text--xmd">
                        {item.provincia}
                      </span>
                    </Card.Title>
                    <Card.Title>
                      <span className="text--lato">{item.codigoPromocion}</span>
                    </Card.Title>
                    <Card.Text className="d-flex">
                      {item?.tipoActivo}
                      {( item?.tipoActivo || item?.direccion ) && (
                      <IconPin className="mx-2" />
                      )}
                      {item?.direccion}
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer className="pb-3">
                    <Button
                      variant="blue"
                    >
                      <span className="btn-icon-rounded">
                        <i className="icon-arrow-right" />
                      </span>
                      Ver mas
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ) )}
          </Row>
        </div>

        {paginatedProjects.length > 0 && (
          <Pagination className="justify-content-center mt-3">
            <Pagination.Prev
              onClick={() => setCurrentPage( ( prev ) => Math.max( prev - 1, 1 ) )}
              disabled={currentPage === 1}
            >
              <IconArrowRight />
            </Pagination.Prev>

            {visiblePages.map( ( page ) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => setCurrentPage( page )}
              >
                {page}
              </Pagination.Item>
            ) )}

            <Pagination.Next
              onClick={() => setCurrentPage( ( prev ) => Math.min( prev + 1, totalPages ) )}
              disabled={currentPage === totalPages}
            >
              <IconArrowLeft />
            </Pagination.Next>
          </Pagination>
        )}

      </Card>
    </div>
  );
}

export default Opportunities;
